import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import AddCardIcon from "@mui/icons-material/AddCard";
import toast from "react-hot-toast";
import { cancelSuscription } from "../../../services/rest/membership/membershipService";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearMembership } from "../../../redux/slice/membershipSlice";

const ModalDetailsOfMembership = ({ open, setOpen, setLoading }) => {
  const { planName, membershipStatus, lastPayment, nextPayment } = useSelector(
    (state) => state.membershipReducer
  );
  const { _id } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };
  const formatDate = (date) => {
    const dateObj = new Date(date);

    const fechaFormateada = dateObj.toLocaleString("es-MX", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    return fechaFormateada;
  };
  const handleCancelSuscription = async () => {
    try {
      setLoading(true);
      await cancelSuscription({ _id });
      dispatch(clearMembership());
      handleClose();
      navigate("/dashboard/account");
      setLoading(false);
      toast.success("Suscripción cancelada con éxito");
    } catch (error) {
      setLoading(false);
      // console.log("Error al cancelar suscripcion", error);
      toast.error("Error al cancelar la suscripción");
    }
  };
  return (
    <Dialog open={open}>
      <DialogContent sx={{ padding: 5 }}>
        <DialogTitle>
          <Typography sx={{ textAlign: "center", fontSize: 24 }}>
            Membresía {planName}
          </Typography>
        </DialogTitle>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                display: "flex",
                gap: 2,
              }}
              variant="h5"
            >
              Status:
            </Typography>
            <Typography
              sx={{ color: membershipStatus === "active" ? "green" : "red" }}
              variant="h5"
            >
              {membershipStatus === "inactive"
                ? "Inactiva"
                : membershipStatus === "active" && "Activa"}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              borderColor: "white",
              borderWidth: 1,
            }}
          >
            <Box sx={{ display: "flex", gap: 1 }}>
              <CreditScoreIcon sx={{ color: "#e7ef7d" }} />
              <Typography sx={{ textAlign: "center" }}>Último pago:</Typography>
            </Box>
            <Typography sx={{ textAlign: "center" }}>
              {lastPayment && formatDate(lastPayment)}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Box sx={{ display: "flex", gap: 1 }}>
              <AddCardIcon sx={{ color: "#e7ef7d" }} />
              <Typography sx={{ textAlign: "center", display: "flex", gap: 1 }}>
                Proximo pago:
              </Typography>
            </Box>
            <Typography sx={{ textAlign: "center" }}>
              {nextPayment && formatDate(nextPayment)}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        {membershipStatus !== "inactive" && (
          <Button
            variant="text"
            onClick={handleCancelSuscription}
            sx={{ borderColor: "white", color: "white" }}
          >
            Cancelar Suscripción
          </Button>
        )}
        <Button
          variant="contained"
          onClick={handleClose}
          sx={{ backgroundColor: "#e7ef7d" }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDetailsOfMembership;
